module.exports = __webpack_public_path__ + "static/media/search.c5518ef7.svg";